import { amplitudeSendEvent, getScreenName } from '@musinsa/frontend-utils';
import { Typography } from '@musinsa/mds';
import { Tooltip } from '@musinsa/mds-ui';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useQuery } from '@tanstack/react-query';
import { twMerge } from 'tailwind-merge';
import { useCuratorSnackbar } from '../../common/hooks';
import { curatorQueries } from '../../query-factory';

interface Props {
  className?: string;
  curationId: string;
  curationIndex: number;
  curationType?: 'GOODS' | 'SNAP2' | null;
  onClose: () => void;
}

export const CurationCopyShortLink = ({
  className,
  curationId,
  curationIndex,
  curationType,
  onClose,
}: Props) => {
  const snackbar = useCuratorSnackbar();
  const { service } = useDeviceInfo();
  const { data: shortLinkData } = useQuery({
    ...curatorQueries.link.getLinkCuration({
      curationId,
    }),
  });
  const { data: userInfo } = useQuery({ ...curatorQueries.profile.userInfo });

  const handleClick = () => {
    // FIXME: shortLink를 동적으로 Fetch하면 Safari Clipboard API 정책에 위배되어 미리 fetch해둔 값으로 갈음한다.
    // 참고 url: https://www.reddit.com/r/webdev/comments/1ge5ou7/why_does_clipboard_access_fail_in_safari_after_an/
    if (!shortLinkData?.shortLink) return;

    if (service === SERVICE.MUSINSA) {
      // NOTE: mss-curator legacy payload 픽셀 일치를 위해 action / contents_name 키 그대로 유지
      amplitudeSendEvent({
        action: 'click',
        button_name: 'curatorlink_copy',
        contents_name: 'button',
        event_name: 'click_button',
        from: getScreenName(),
        id: userInfo?.snsTitle ?? '',
        index: curationIndex,
        name: 'shop_curation',
        section_name: 'curator_curationfeed',
        type: curationType === 'SNAP2' ? 'snap' : 'goods',
      });
    }

    snackbar.success('바로가기 링크가 복사되었습니다.');
    navigator.clipboard.writeText(shortLinkData.shortLink);
    onClose();
  };

  return (
    <Typography
      className={twMerge('relative pt-[4px]! pb-[12px]! space-y-[11px] cursor-pointer', className)}
      colorScheme="gray-600"
      variant="body13pxReg"
      onClick={handleClick}
    >
      바로가기 링크 복사
      <Tooltip
        className="!absolute left-[110px] -top-3"
        align="right center"
        content={
          <>
            링크를 공유하면 선택한 큐레이션을
            <br />
            가장 먼저 보여줄 수 있습니다.
          </>
        }
        duration={5000}
        storageKey="tooltip-curation-copy-short-link"
        maxCount={1}
      />
    </Typography>
  );
};
